<template>
  <div>
      <b-form-file
          :required="this.currentField.isRequired"
          multiple
          :name="`formData[${currentField.tagname}]`"
          v-model="fileList"
          :state="Boolean(fileList.length)"
          :class="{'is-invalid' : error}"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        ></b-form-file>
        <span class="invalid-feedback" role="alert" v-if="error">
            <strong>{{ error }}</strong>
        </span>
        <template v-if="fileList.length > 0">
          <div class="mt-3">Selected file(s):</div>
          <div class="mt-1" v-for="(file, fileIndex) in fileList" :key="fileIndex">{{ file.name }}</div>
        </template>
  </div>
</template>
<script>
export default {
  name: 'Upload',
  props: ['currentField', 'error'],
  data() {
    return {
      fileList: []
    };
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`The limit is 3, you selected ${files.length} files this time, add up to ${files.length + fileList.length} totally`);
    },
    beforeRemove(file, fileList) {
      console.log(fileList)
      return this.$confirm(`Cancel the transfert of ${ file.name } ?`);
    }
  }
}
</script>
